module.exports = __webpack_public_path__ + "img/about/80243-014.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-014.png
// module id = 24
// module chunks = 0